import React from 'react'
import { Section } from '~co/common/list'

export function MenuSection(props){
    return <Section {...props} />
}